import React, { useEffect, useState } from "react";
import api, { asArray } from "../lib/api";
import { useI18n } from "../contexts/I18nContext";
import useReveal from "../hooks/useReveal";
import * as Icons from "lucide-react";

export default function ServicesPage() {
    const { t, pick, isRTL } = useI18n();
    const ref = useReveal();
    const [services, setServices] = useState([]);

    useEffect(() => {
        api.get("/services").then((r) => setServices(asArray(r.data, "services"))).catch(() => {});
    }, []);

    return (
        <div ref={ref} data-testid="services-page">
            <section className="bg-[#EFF0F1] py-20 md:py-28">
                <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
                    <div className="section-eyebrow mb-5 plus-mark">
                        {t("section_services_overline")}
                    </div>
                    <h1 className="heading page-hero-oneline">
                        {t("section_services_title")}
                    </h1>
                </div>
            </section>

            <section className="bg-white py-14 md:py-20">
                <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
                        {services.map((s, i) => {
                            const Icon = Icons[s.icon] || Icons.Sparkles;
                            return (
                                <div key={s.id} className="service-card min-h-[300px] reveal" data-testid={`service-row-${i}`}>
                                    <div className="flex h-full flex-col">
                                        <div className="flex items-start justify-between gap-6">
                                            <div className="service-number">0{i + 1}</div>
                                            <div className="border border-[#002951]/15 bg-white p-3 text-[#002951] transition-colors group-hover:border-[#0060A7] group-hover:text-[#0060A7]">
                                                <Icon size={26} strokeWidth={1.5} />
                                            </div>
                                        </div>
                                        <div className="mt-8">
                                            <div className="section-eyebrow mb-4 text-[#0060A7]">
                                                {isRTL ? "خدمة" : "Service"}
                                            </div>
                                            <h2 className="heading text-2xl md:text-3xl tracking-tight mb-4 font-bold text-[#002951]">
                                                {pick(s, "title")}
                                            </h2>
                                            <p className="text-base md:text-lg leading-relaxed text-[#374151]">
                                                {pick(s, "description")}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>
        </div>
    );
}
